"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DeliveryAddressFormComponent = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var R = _interopRequireWildcard(require("ramda"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _reactRedux = require("react-redux");

var _styles = require("@mui/styles");

var _reactUse = require("react-use");

var _commonData = require("../../../Shared/store/commonData");

var _invitationType = require("../../store/gift/invitationType");

var _address = require("../../store/address");

var _address2 = require("../../store/address/address.actions");

var _gift = require("../../store/gift/gift.selector");

var _shipping = require("../../store/shipping/shipping.actions");

var _shipping2 = require("../../store/shipping");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing,
      zIndex = _ref.zIndex,
      breakpoints = _ref.breakpoints;
  return {
    wrapper: {
      position: 'relative',
      marginTop: 16
    },
    popper: {
      zIndex: zIndex.tooltip,
      border: "1px solid ".concat(palette.primary.main),
      borderRadius: 5,
      backgroundColor: palette.common.white,
      width: 484,
      left: '-38px !important',
      marginTop: "".concat(spacing(1), " !important"),
      [breakpoints.down('lg')]: {
        maxWidth: 400,
        width: 400
      },
      [breakpoints.down('sm')]: {
        maxWidth: 320,
        width: 320,
        transform: 'translate3d(38px, -270px, 0px) !important'
      }
    },
    list: {
      [breakpoints.down('sm')]: {
        maxHeight: 250,
        overflow: 'auto'
      }
    },
    listOption: {
      marginTop: 6,
      marginBottom: 6
    },
    listOptionText: {
      fontSize: 16,
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1.5,
      letterSpacing: 'normal',
      color: palette.text.primary
    },
    searchIcon: {
      marginRight: spacing(0.5)
    }
  };
});
var MIN_SEARCH_LENGTH = 3;

var DeliveryAddressFormComponent = function DeliveryAddressFormComponent(_ref2) {
  var onUpdateField = _ref2.onUpdateField,
      address = _ref2.address,
      disabled = _ref2.disabled,
      errors = _ref2.errors,
      _onFocus = _ref2.onFocus;
  var governments = (0, _reactRedux.useSelector)(_commonData.CommonData.selectors.getGovernments);
  var dispatch = (0, _reactRedux.useDispatch)();
  var countries = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    return _commonData.CommonData.selectors.makeGetAvailableCountries();
  }, []));
  var isDirectDeliveryMethod = (0, _reactRedux.useSelector)(_invitationType.getIsSelectedDirectMailInvitationType);
  var giftId = (0, _reactRedux.useSelector)(_gift.getGiftId);
  var classes = useStyles();
  var verificationErrors = (0, _reactRedux.useSelector)(_shipping2.getErrors);
  var addresses = (0, _reactRedux.useSelector)(_address.getAddresses);
  var isLoading = (0, _reactRedux.useSelector)(_address.getIsAddressesLoading);
  var isLoaded = (0, _reactRedux.useSelector)(_address.getIsAddressesLoaded);
  var addressesMap = (0, _reactRedux.useSelector)(_address.getAddressesMap);
  var addressesIdsFromState = (0, _reactRedux.useSelector)(_address.getAddressesIds);
  var inputRef = (0, _react.useRef)(null);
  var isMount = (0, _react.useRef)(false);

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      search = _useState4[0],
      setSearch = _useState4[1];

  var _useState5 = (0, _react.useState)(!isDirectDeliveryMethod),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      showFormAddress = _useState6[0],
      setShowFormAddress = _useState6[1];

  var isOpen = !!anchorEl;
  var addressesIds = (0, _react.useMemo)(function () {
    return isLoading ? Array.from({
      length: 5
    }) : addressesIdsFromState;
  }, [isLoading, addressesIdsFromState]);
  (0, _react.useEffect)(function () {
    return function () {
      setShowFormAddress(false);
    };
  }, [isDirectDeliveryMethod]);
  var handleEnterManual = (0, _react.useCallback)(function () {
    setShowFormAddress(true);
    dispatch((0, _shipping.setManualAddressMode)(true));
  }, [dispatch, setShowFormAddress]);
  var handleOpen = (0, _react.useCallback)(function (event) {
    if (isLoaded && addresses.length > 0) {
      setAnchorEl(event.currentTarget);
    }
  }, [isLoaded, addresses]);
  var handleClose = (0, _react.useCallback)(function () {
    setAnchorEl(null);
  }, []);
  var handleOnChangeSearch = (0, _react.useCallback)(function (_ref3) {
    var value = _ref3.target.value;
    setSearch(value);
  }, []);
  var handleSelectAddress = (0, _react.useCallback)(function (option) {
    onUpdateField({
      address_line_1: option.deliveryAddressLines.join(' '),
      address_line_2: '',
      state: option.stateName,
      stateCode: option.stateCode,
      zip: option.zipcode,
      city: option.city
    });
    setShowFormAddress(true);
    setAnchorEl(null);
  }, [onUpdateField]);
  (0, _react.useEffect)(function () {
    if (isLoaded) {
      var isAddressListVisible = search.length >= MIN_SEARCH_LENGTH && addresses.length > 0;
      setAnchorEl(isAddressListVisible ? inputRef.current : null);
    }
  }, [isLoaded, addresses, search]);
  (0, _reactUse.useDebounce)(function () {
    if (isMount.current && search.length >= MIN_SEARCH_LENGTH) {
      dispatch((0, _address2.loadAddressRequest)({
        giftId,
        address: search
      }));
    }
  }, 300, [search, giftId, dispatch]);
  (0, _reactUse.useMount)(function () {
    isMount.current = true;
  });
  var getStatesList = (0, _react.useMemo)(function () {
    return governments[address.country_id || 1].map(function (state) {
      return {
        label: state.name,
        value: {
          full: state.name,
          short: state.abbr
        }
      };
    });
  }, [address, governments]);
  var stateValue = (0, _react.useMemo)(function () {
    return getStatesList.find(function (_ref4) {
      var value = _ref4.value;
      return value.full === address.state;
    });
  }, [address, getStatesList]);
  var stateFieldFilter = (0, _react.useCallback)(function (items, changes) {
    return items.filter(function (item) {
      return item.value.full.toLowerCase().includes(changes.inputValue.toLowerCase()) || R.equals(item.value.short, changes.inputValue.toUpperCase());
    });
  }, []);
  var handleChangeState = (0, _react.useCallback)(function (_, option) {
    onUpdateField({
      state: option.value.full,
      stateCode: option.value.short
    });

    _onFocus('state');
  }, [_onFocus, onUpdateField]);
  var handleChangeCountry = (0, _react.useCallback)(function (data) {
    onUpdateField({
      country_id: data.country_id
    });
  }, [onUpdateField]);
  return /*#__PURE__*/_react.default.createElement("form", null, isDirectDeliveryMethod && /*#__PURE__*/_react.default.createElement(_material.TextField, {
    fullWidth: true,
    error: !!(verificationErrors && verificationErrors.phone),
    helperText: verificationErrors && verificationErrors.phone,
    disabled: disabled,
    label: "Phone number",
    variant: "outlined",
    margin: "normal",
    value: address.phone,
    onFocus: function onFocus() {
      _onFocus('phone');
    },
    onChange: function onChange(e) {
      return onUpdateField({
        phone: e.target.value
      });
    }
  }), isDirectDeliveryMethod && !showFormAddress && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.wrapper
  }, /*#__PURE__*/_react.default.createElement(_material.TextField, {
    inputRef: inputRef,
    label: "Street address",
    placeholder: "Start typing address",
    fullWidth: true,
    variant: "outlined",
    disabled: disabled,
    value: search,
    onChange: function onChange(event) {
      handleOnChangeSearch(event);
    },
    "data-testid": "ShippingAddressForm.RecipientAddress",
    "data-private": "lipsum",
    autoComplete: "nope",
    onFocus: handleOpen,
    InputProps: {
      startAdornment: /*#__PURE__*/_react.default.createElement(_ui.Icon, {
        className: classes.searchIcon,
        icon: "search",
        color: "grey.main"
      }),
      endAdornment: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isLoading ? /*#__PURE__*/_react.default.createElement(_material.CircularProgress, {
        color: "inherit",
        size: 20
      }) : null)
    }
  }), /*#__PURE__*/_react.default.createElement(_material.Popper, {
    open: isOpen,
    transition: true,
    anchorEl: anchorEl,
    placement: "bottom-start",
    className: classes.popper,
    disablePortal: true
  }, function (_ref5) {
    var TransitionProps = _ref5.TransitionProps,
        placement = _ref5.placement;
    return /*#__PURE__*/_react.default.createElement(_material.Grow, (0, _extends2.default)({}, TransitionProps, {
      style: {
        transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
      }
    }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_material.ClickAwayListener, {
      onClickAway: handleClose
    }, /*#__PURE__*/_react.default.createElement(_material.List, {
      className: classes.list
    }, addressesIds.map(function (addressId, index) {
      return /*#__PURE__*/_react.default.createElement(_material.ListItem, {
        classes: {
          dense: classes.listOption
        },
        key: addressId !== null && addressId !== void 0 ? addressId : index,
        role: "button",
        dense: true,
        button: true,
        onClick: function onClick() {
          if (addressId) {
            handleSelectAddress(addressesMap[addressId]);
          }
        }
      }, addressId ? /*#__PURE__*/_react.default.createElement(_material.ListItemText, {
        classes: {
          primary: classes.listOptionText
        },
        className: "Body-Regular-Left-Static",
        primary: addressesMap[addressId].formattedAddress
      }) : /*#__PURE__*/_react.default.createElement(_material.Box, {
        width: 1,
        my: 0.5
      }, /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
        width: "100%",
        height: 24
      })));
    })))));
  }))), isDirectDeliveryMethod && !showFormAddress && /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    mt: 2
  }, /*#__PURE__*/_react.default.createElement(_ui.LinkButton, {
    onClick: handleEnterManual
  }, "Enter address manually")), showFormAddress && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.TextField, {
    fullWidth: true,
    error: !!(errors && errors.address_line_1),
    helperText: errors && errors.address_line_1,
    disabled: disabled,
    label: "Street address",
    variant: "outlined",
    margin: "normal",
    value: address.address_line_1,
    onFocus: function onFocus() {
      _onFocus('address_line_1');
    },
    onChange: function onChange(e) {
      return onUpdateField({
        address_line_1: e.target.value
      });
    }
  }), /*#__PURE__*/_react.default.createElement(_material.TextField, {
    fullWidth: true,
    error: !!(errors && errors.address_line_2),
    helperText: errors && errors.address_line_2,
    disabled: disabled,
    label: "Apt / Suite / Other",
    variant: "outlined",
    margin: "normal",
    value: address.address_line_2,
    onFocus: function onFocus() {
      _onFocus('address_line_2');
    },
    onChange: function onChange(e) {
      return onUpdateField({
        address_line_2: e.target.value
      });
    }
  }), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row",
    wrap: "nowrap",
    spacing: 2,
    pb: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/_react.default.createElement(_material.TextField, {
    fullWidth: true,
    error: !!(errors && errors.city),
    helperText: errors && errors.city,
    disabled: disabled,
    label: "City",
    variant: "outlined",
    margin: "normal",
    value: address.city,
    onFocus: function onFocus() {
      _onFocus('city');
    },
    onChange: function onChange(e) {
      return onUpdateField({
        city: e.target.value
      });
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/_react.default.createElement(_ui.SelectField, {
    items: getStatesList,
    filter: stateFieldFilter,
    variant: "outlined",
    label: address.country_id === 1 ? 'State' : 'Province',
    selectedItem: stateValue || null,
    error: !!(errors && errors.state),
    helperText: errors && errors.state,
    disabled: disabled,
    onChange: handleChangeState
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/_react.default.createElement(_material.TextField, {
    fullWidth: true,
    error: !!(errors && errors.zip),
    helperText: errors && errors.zip,
    disabled: disabled,
    label: address.country_id === 1 ? 'Zip code' : 'Postal code',
    variant: "outlined",
    margin: "normal",
    value: address.zip,
    onChange: function onChange(e) {
      return onUpdateField({
        zip: e.target.value
      });
    },
    onFocus: function onFocus() {
      _onFocus('zip');
    }
  }))), /*#__PURE__*/_react.default.createElement(_ui.SelectFilter, {
    fullWidth: true,
    error: !!(errors && errors.country_id),
    helperText: errors && errors.country_id,
    disabled: disabled || isDirectDeliveryMethod,
    onFilterChange: handleChangeCountry,
    renderItems: function renderItems() {
      return countries.map(function (countryItem) {
        return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
          key: countryItem.id,
          value: countryItem.id
        }, countryItem.name);
      });
    },
    label: "Country",
    value: address.country_id,
    name: "country_id",
    onOpen: function onOpen() {
      _onFocus('country_id');
    }
  })));
};

exports.DeliveryAddressFormComponent = DeliveryAddressFormComponent;
DeliveryAddressFormComponent.propTypes = {
  onUpdateField: _propTypes.default.func.isRequired,
  address: _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])).isRequired,
  onFocus: _propTypes.default.func,
  // eslint-disable-next-line react/forbid-prop-types
  errors: _propTypes.default.object,
  disabled: _propTypes.default.bool
};
DeliveryAddressFormComponent.defaultProps = {
  onFocus: function onFocus() {},
  errors: null,
  disabled: false
};
var _default = DeliveryAddressFormComponent;
exports.default = _default;